import { Link } from "react-router-dom";
import { Shield, Truck, Headphones, Lock, CreditCard } from "lucide-react";
import paymentIcons from "@/assets/payment-badges.png";

const Footer = () => (
  <footer className="gradient-dark text-white">
    {/* Trust Bar */}
    <div className="border-b border-white/10">
      <div className="container mx-auto px-6 lg:px-12 py-6">
        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-white/70">
          <div className="flex items-center gap-2"><Lock size={14} className="text-cta" /> Secure Encrypted Checkout</div>
          <div className="hidden sm:block w-px h-4 bg-white/20" />
          <div className="flex items-center gap-2"><Shield size={14} className="text-cta" /> 30-Day Risk-Free Guarantee</div>
          <div className="hidden sm:block w-px h-4 bg-white/20" />
          <div className="flex items-center gap-2"><Truck size={14} className="text-cta" /> Free UK Shipping 🇬🇧</div>
        </div>
      </div>
    </div>

    <div className="container mx-auto px-6 lg:px-12 py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-xl gradient-primary flex items-center justify-center">
              <span className="text-white font-bold text-sm">L</span>
            </div>
            <div>
              <span className="font-serif text-xl text-white tracking-tight block leading-none">Luminaease</span>
              <span className="text-[8px] font-semibold tracking-[0.25em] uppercase text-white/40 leading-none">Wellness Technology</span>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-white/50 mb-6">
            Premium wellness technology for daily relaxation and digital eye recovery.
          </p>
          {/* Payment Badges */}
          <div className="inline-flex items-center bg-white/10 backdrop-blur-[12px] rounded-xl px-4 py-2.5 border border-white/[0.15] shadow-[0_10px_30px_rgba(0,0,0,0.2)]">
            <img src={paymentIcons} alt="Accepted payment methods — Amazon, Amex, Apple Pay, Bancontact, Discover, GPay, Mastercard, Shop Pay, Visa" width={280} height={48} className="h-12 object-contain" />
          </div>
        </div>
        <div>
          <h4 className="text-xs font-bold tracking-widest uppercase text-white/30 mb-4">Navigate</h4>
          <div className="flex flex-col gap-3">
            {[{ to: "/", label: "Home" }, { to: "/product", label: "Shop" }, { to: "/about", label: "About" }].map(l => (
              <Link key={l.to} to={l.to} className="text-sm text-white/50 hover:text-white transition-colors">{l.label}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs font-bold tracking-widest uppercase text-white/30 mb-4">Support</h4>
          <div className="flex flex-col gap-3">
            {[{ to: "/faq", label: "FAQ" }, { to: "/shipping", label: "Shipping Policy" }, { to: "/returns", label: "Returns & Refunds" }, { to: "/privacy", label: "Privacy Policy" }, { to: "/terms", label: "Terms & Conditions" }, { to: "/contact", label: "Contact" }].map(l => (
              <Link key={l.to} to={l.to} className="text-sm text-white/50 hover:text-white transition-colors">{l.label}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs font-bold tracking-widest uppercase text-white/30 mb-4">Our Promise</h4>
          <div className="flex flex-col gap-3">
            {[
              { icon: Shield, label: "30-Day Guarantee" },
              { icon: Truck, label: "Free UK Shipping 🇬🇧" },
              { icon: Headphones, label: "24/7 Support" },
              { icon: CreditCard, label: "Secure Payments" },
            ].map((t, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-white/50">
                <t.icon size={14} className="text-cta" /> {t.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 mt-12 pt-8 text-center text-xs text-white/30">
        © {new Date().getFullYear()} Luminaease. All rights reserved. | Secure Payments • Encrypted Checkout • 30-Day Risk-Free Guarantee
      </div>
    </div>
  </footer>
);

export default Footer;
